const labels = [
  {
    name: 'S.No',
    value: 'index',
  },
  {
    name: 'Company Name',
    value: 'companyName',
  },
  {
    name: 'Contact Person',
    value: 'contactName',
  },
  {
    name: 'Contact Email',
    value: 'contactEmail',
  },
  {
    name: 'Contact Mobile',
    value: 'contactMobile',
  },
  {
    name: 'Register Date',
    value: 'time',
  },
];

const corporateConnectcsv = (JSONData, fileName = 'Corporate Connect') => {
  const arrData =
    typeof JSONData !== 'object' ? JSON.parse(JSONData) : JSONData;
  let csv = '';
  let row = '';
  labels.forEach((fieldName) => {
    row += `${fieldName.name},`;
  });
  row = row.slice(0, -1);
  csv += `${row}\r\n`;

  for (let i = 0; i < arrData.length; i += 1) {
    row = '';
    const arrRow = arrData[i];
    // eslint-disable-next-line
    labels.forEach(fieldName => {
      const { value } = fieldName;
      if (value === 'index') {
        row += `${i + 1},`;
      } else {
        const arrValue =
          typeof arrRow[value] === 'undefined' ? '' : `"${arrRow[value]}"`;
        row += `${arrValue},`;
      }
    });
    row.slice(0, row.length - 1);
    csv += `${row}\r\n`;
  }

  if (csv === '') {
    return;
  }

  const uri = `data:application/csv;charset=utf-8,${escape(csv)}`;
  const link = document.createElement('a');
  link.href = uri;
  link.style = 'visibility:hidden';
  link.download = `${fileName}.csv`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};

export default corporateConnectcsv;



// WEBPACK FOOTER //
// ./src/utils/CorporateConnectCSV.js